import React, { Component } from "react";
import { connect } from "react-redux";
import SignInContainer from "../../components/containers/SignInContainer";
import { Row, Col } from "antd";
import plantBackgroundImage from "../../assets/images/404-bg.png";
import plantBrokentLink from "../../assets/images/brokent-link.png";
import plantEmptyTower from "../../assets/images/trkr.png"
import plantbackgroundImg404 from "../../assets/images/404.png";
import ValidateUser from "../../components/ExpireLink";
import { AuthAction } from "../../store/actions";

class Not_found extends Component {
    constructor(props) {
        super(props);

    }

    render() {
        const { storeName, getStoreName } = this.props
        return (
            <Row justify="center">
                <Col xs={22} sm={18} md={12} lg={11} xl={24}>
                    <ValidateUser
                        backgroundImage={plantBackgroundImage}
                        ImageWidth="433px"
                        ImageHeight="237px"
                        brokentLinkImage={plantbackgroundImg404}
                        emptyTowerImage={plantEmptyTower}
                        trkrText="Oops......"
                        trkrDescription="looks like you lost your way!"
                        exitsText="  The page you are looking for no longer exists"
                    />
                </Col >
            </Row >
        );
    }
}

function mapStateToProps(storeState) {
    return {
        loader: storeState?.AuthReducer.loader,
        error: storeState?.AuthReducer.error,
        // storeName: storeState?.AuthReducer.storeInfo,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        // getStoreName: (data) => dispatch(AuthAction.getStoreUrlReq(data)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Not_found);
